import React from "react";

const RouletteModal = ({
  isActive,
  className,
  cellNumber,
  amount,
  range,
  status,
  color,
  logo,
}) => {
  return (
    <>
      {isActive ? (
        <div
          className={`${className} ${
            status === "win" ? "border-[#00d30e]" : "border-[#434343]"
          } bg-[#0d0d0d] border-[3px] font-redHat flex flex-col gap-y-2 items-center justify-center md:h-60 sm:h-52 h-48 w-fit md:px-12 px-10 rounded-2xl`}
        >
          <div
            style={{
              backgroundColor: `${color}`,
            }}
            className="md:h-16 md:w-16 sm:h-14 sm:w-14 h-12 w-12 rounded-lg flex items-center justify-center"
          >
            <h1 className="text-2xl">{cellNumber}</h1>
          </div>
          <div
            className={`${
              status === "win" ? "text-[#00d30e]" : "text-[#2c2c2c]"
            } flex flex-col items-center`}
          >
            <div
              className={`md:text-[48px] sm:text-[40px] text-[32px] font-bold flex justify-center items-center gap-x-1`}
            >
              <h1>{range}X</h1>
            </div>
            <div className="flex gap-x-1 items-center">
              <span className="md:text-xl sm:text-lg text-base">{amount}</span>
              <img src={logo} className="md:h-4 sm:h-3.5 h-3" alt={logo} />
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default RouletteModal;
